<div class="widget-sport-event">
    <div class="widget-sport-event-head">
        <div class="widget-sport-event-head-title">
            {{ 'worldCup.title' | translate }}
        </div>
    </div>
    @if (isIncoming()) {
    <div class="widget-sport-event-content">
        <div class="widget-sport-event-content-box">
            <owl-carousel-o [options]="customOptions">
                @for (item of worldCupScheduleData().listDay; track $index) {
                <ng-template carouselSlide>
                    <button class="schedule-box" [ngClass]="{'active-selection': item.day === currentDay}"
                        (click)="changeDay(item)">
                        <div class="schedule-box-day" [class.active]="item.day === currentDay">{{ item?.day }}</div>
                        <div class="schedule-box-datetime">{{ item?.date }}</div>
                        @if (item.day === currentDay) {
                        <div class="schedule-box-border"></div>
                        }
                    </button>
                </ng-template>
                }
            </owl-carousel-o>
        </div>
        @for (item of worldCupScheduleData().listDay; track $index) {
        <div>
            @if (item.day === currentDay) {
            <div class="widget-sport-event-content-inner">
                @for (list of item?.matchLists; track $index) {
                <div class="widget-sport-event-content-inner-card">
                    <div class="widget-sport-event-content-inner-card-row">
                        <div class="highlight-card">Group {{ list.group }}</div>
                        <div class="highlight-card">{{ this.selectedLang === 'id' ? 'Pukul' : '' }} {{ list.time }}
                        </div>
                    </div>
                    <div class="widget-sport-event-content-inner-card-row">
                        <div class="nationality-card">
                            <img class="country-icon" [src]="list.home_team_img" alt="nationality">
                            <div class="label-card">{{ list.home_team }}</div>
                        </div>
                        <div class="highlight-card">{{ list.home_team_score === null ? '-' : list.home_team_score }}
                        </div>
                    </div>
                    <div class="widget-sport-event-content-inner-card-row">
                        <div class="nationality-card">
                            <img class="country-icon" [src]="list.away_team_img" alt="nationality">
                            <div class="label-card">{{ list.away_team }}</div>
                        </div>
                        <div class="highlight-card">{{ list.away_team_score === null ? '-' : list.away_team_score }}
                        </div>
                    </div>
                </div>
                }
            </div>
            }
        </div>
        }
    </div>
    }@else {
    <div class="widget-sport-event-content not-started">
        <div class="widget-sport-event-content-box">
            <div ngxSlickItem class="schedule-box not-started">
                <div class="schedule-box-day">Yang akan datang</div>
                <div class="schedule-box-border"></div>
            </div>
        </div>
        @for (item of worldCupScheduleData().listDay.slice(0,(limit * (page + 1))); track $index) {
        <div class="not-started">
            <div class="widget-sport-event-content-title">{{ item.date }}</div>
            <div class="widget-sport-event-content-inner">
                @for (list of item?.matchLists; track $index) {
                <div class="widget-sport-event-content-inner-card">
                    <div class="widget-sport-event-content-inner-card-row">
                        <div class="highlight-card">Group {{ list.group }}</div>
                        <div class="highlight-card">Pukul: {{ list.time }}</div>
                    </div>
                    <div class="widget-sport-event-content-inner-card-row">
                        <div class="nationality-card">
                            <img class="country-icon" [src]="list.home_team_img" alt="nationality">
                            <div class="label-card">{{ list.home_team }}</div>
                        </div>
                        <div class="highlight-card">{{ list.home_team_score === null ? '-' : list.home_team_score }}
                        </div>
                    </div>
                    <div class="widget-sport-event-content-inner-card-row">
                        <div class="nationality-card">
                            <img class="country-icon" [src]="list.away_team_img" alt="nationality">
                            <div class="label-card">{{ list.away_team }}</div>
                        </div>
                        <div class="highlight-card">{{ list.away_team_score === null ? '-' : list.away_team_score }}
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
        }

        @if (worldCupScheduleData().listDay.length > limit * (page + 1)) {
        <button class="btn-secondary-submit" (click)="page = page + 1">Muat lebih banyak
        </button>
        }
    </div>
    }
</div>